define([
    'text!cooperate/component/item-design.html',
    'cooperate/mixin/form'
], function(
    tpl,
    FormMixin
){
    return {
        template: tpl,
        mixins: [FormMixin],
        methods: {
            resetForm: function(){
                this.form = {
                    type: 2,
                    companyName: '',
                    contact: '',
                    tel: '',
                    email: '',
                    attch: '',
                    remark: ''
                };
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./cooperate/component/item-design.js
// module id = 213
// module chunks = 0